import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

export const convertDeltaToText = (delta) => {
  const html = convertDeltaToHtml(delta);
  const text = convertHtmlToText(html);
  return text;
};

export const convertDeltaToHtml = (delta) => {
  const converter = new QuillDeltaToHtmlConverter(delta.ops);
  const html = converter.convert();
  return html;
};

export const convertHtmlToText = (html) => {
  const parsedText = new DOMParser().parseFromString(html, "text/html");
  const text = parsedText.body.textContent || "";
  return text;
};

export const indexer = (page, pageSize, total) => {
  return (i) => total - (page - 1) * pageSize - i;
};
